export default __webpack_public_path__ + "static/media/protected_dmca.e84db0e0.svg";